﻿export const widgetToggle = () => {
    const init = component => {
        const widget = component.querySelector('.zen-widget');
        const widgetAlt = component.querySelector('.widget-alt');

        if (widget.shadowRoot) {
            widgetAlt.style.display = "none";
        }
        else {
            widgetAlt.style.display = "flex";
        }
    };

    return {
        init: init,
        selector: '[data-component="widget-alt"]'
    };
};